import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  InputAdornment,
  TextField,
  Typography,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import Tenders from "./Tenders";
import SuccessModal from "../../utils/SuccessModal";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../utils/ErrorModal";
import ItemCount from "../../utils/ItemCount";
import { viewPDF } from "../../utils/viewPDF";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { uploadFile } from "../../utils/uploadToAzure";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3,
  textAlign: "center",
};

const MyTenders = () => {
  const [tenders, setTenders] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(
    localStorage.getItem("activeTab") || "SHORTLISTED"
  );
  const [id, setId] = useState();
  const [searchTender, setSearchTender] = useState();
  const [searchLoading, setSearchLoading] = useState(false);
  const [vendor, setVendor] = useState();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openPurchase, setOpenPurchase] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [purchase, setPurchase] = useState();
  const [errorMsg, setErrorMsg] = useState();
  const [shortlistCount, setShortlistCount] = useState(0);
  const [preCount, setPreCount] = useState(0);
  const [inCount, setInCount] = useState(0);
  const [postCount, setPostCount] = useState(0);
  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [fileNames, setFileNames] = useState({
    document: "",
  });

  useEffect(() => {
    if (!vendor) return;
    const getShortlistCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/item?vendorId=${vendor.vendorId}&status=SHORTLISTED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setShortlistCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getShortlistCount();

    const getPreCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/item?vendorId=${vendor.vendorId}&status=PREBIDDING`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPreCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPreCount();

    const getInbiddingCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/item?vendorId=${vendor.vendorId}&status=INBIDDING`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setInCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getInbiddingCount();

    const getPostCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/item?vendorId=${vendor.vendorId}&status=POSTBIDDING`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPostCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPostCount();
    localStorage.removeItem("activeTab");
  }, [vendor]);

  const handleClose = () => {
    setOpen(false);
    setOpenError(false);
    setErrorMsg("");
    setOpenPurchase(false);
  };

  useEffect(() => {
    const getVendor = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor?email=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        if (
          !res.data.name ||
          !res.data.firmName ||
          !res.data.pan ||
          !res.data.categories ||
          !res.data.categories.length === 0
        ) {
          navigate("/vendor/details");
        }
        localStorage.setItem("vendor", JSON.stringify(res.data.vendorId));
        setVendor(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getVendor();
  }, []);

  const getTenders = async (page) => {
    if (!vendor) return;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender?vendorId=${
          vendor.vendorId
        }&status=${status}&page=${page || 0}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTenders(res.data.tenders);
      setTotalCount(res.data.totalCount);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTenders();
  }, [vendor, status]);

  const handleSearchTender = async () => {
    setSearchLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender/search?vendorId=${vendor.vendorId}&tenderId=${id}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setSearchTender(res.data);
      setId("");
    } catch (error) {
      setOpenError(true);
      setErrorMsg(error.response.data.Exception || "Internal server error.");
    } finally {
      setSearchLoading(false);
    }
  };

  const handleShortlistTender = async () => {
    if (btnLoading) return;
    setBtnLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender`,
        {
          vendorId: vendor.vendorId,
          tenderId: searchTender.tenderId,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpen(true);
      setSearchTender("");
      setId("");
      getTenders();
    } catch (error) {
      setOpenError(true);
      setErrorMsg(error.response.data.Exception || "Internal server error.");
    } finally {
      setBtnLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };
  const handleChange = (e) => {
    setPurchase({ ...purchase, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleFileUpload = async (e) => {
    const { name, files } = e.target;
    setUploading(true);
    if (files && files.length > 0) {
      const file = files[0]; // Get the first file

      // Update the file names state
      setFileNames((prev) => ({
        ...prev,
        [name]: file.name, // Set the filename in state
      }));

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await uploadFile(file, searchTender.orgId, searchTender.tenderId, storedUser)
        // Set the received file path in tender state
        setPurchase({ ...purchase, [e.target.name]: res });
        setErrors({ ...errors, [e.target.name]: "" });
      } catch (error) {
        console.error("File upload error:", error);
      } finally {
        setUploading(false);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const data = purchase || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.utr)) newErrors.utr = "UTR Number is required";
    if (isEmpty(data.document)) newErrors.document = "Document is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePurchaseSubmit = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-purchase`,
        {
          vendorId: vendorId,
          tenderId: searchTender.tenderId,
          utr: purchase.utr,
          document: purchase.document,
          documentFilename: fileNames.document,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpenPurchase(false);
      setOpenConfirm(false);
      setFileNames({ document: "" });
      setPurchase();
      setSearchTender("");
      setId("");
      getTenders();
    } catch (error) {
      console.error("Error updating tender status:", error);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div>
      <Typography variant="h5">My Tenders</Typography>
      <Box className="dashboard-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Box>
            <TextField
              placeholder="Search By Tender ID"
              size="small"
              sx={{
                borderRadius: "12px",
                background: "#fff",
                width: 300,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  fontSize: "14px !important",
                },
                "&:hover": { background: "#D8E9F0" },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button onClick={handleSearchTender}>
                      <SearchIcon fontSize="small" />
                    </Button>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => setId(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearchTender();
                }
              }}
              value={id}
            />
          </Box>
        </Box>
        {searchLoading ? (
          <Box textAlign={"center"}>
            <CircularProgress />
          </Box>
        ) : (
          searchTender && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box width={"100%"} my={5}>
                <Grid2 container>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderTop: "1px solid #000" }}
                  >
                    Tender ID
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderTop: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchTender && searchTender.tenderId}
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Title
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{
                      borderRight: "1px solid #000",
                    }}
                  >
                    {searchTender && searchTender.title}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Short Description
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.shortDesc}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Long Description
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.longDesc}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Tender Purchase Date
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender &&
                      formatDate(searchTender.tenderPurchaseDate)}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Tender Publish Date
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && formatDate(searchTender.tenderPublishDate)}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Bid Submission Start Date
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender &&
                      formatDateTime(searchTender.bidSubmissionStartDate)}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Bid Submission End Date
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender &&
                      formatDateTime(searchTender.bidSubmissionEndDate)}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Bid Opening Date
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender &&
                      formatDateTime(searchTender.bidOpeningDate)}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Bid Offer Validity (From End Date) (In Days)
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.bidOfferValidity}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Department Name
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.deptName}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Contact Person Email
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.contactEmail}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Item Category
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.itemCategory}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Contract Period (In Months)
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.contractPeriod}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Documents required from seller
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.sellerDoc}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Type of Tender
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.type}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Time allowed for Technical Clarifications (in days)
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.technicalExpiry}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Estimated Bid Value
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.bidValue}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Evaluation Method
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.evalMethod}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Arbitration Clause
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.arbitrationClause
                      ? "Yes"
                      : "No"}
                  </Grid2>

                  <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                    Mediation Clause
                  </Grid2>
                  <Grid2
                    size={{ xs: 12, sm: 6 }}
                    className="preview-grid"
                    sx={{ borderRight: "1px solid #000" }}
                  >
                    {searchTender && searchTender.mediationClause
                      ? "Yes"
                      : "No"}
                  </Grid2>
                </Grid2>
              </Box>
              <Box>
                {searchTender.isShortlisted ? (
                  <Button
                    className="btn-contained"
                    sx={{ margin: "0 !important" }}
                    disabled
                  >
                    Shortlisted
                  </Button>
                ) : !searchTender.isBorne ? (
                  <Button
                    className="btn-contained"
                    sx={{ margin: "0 !important" }}
                    // onClick={() => setOpenPurchase(true)}
                    onClick={handleShortlistTender}
                    disabled={btnLoading}
                  >
                    Shortlist Purchase Tender
                  </Button>
                ) : (
                  <Button
                    className="btn-contained"
                    sx={{ margin: "0 !important" }}
                    onClick={handleShortlistTender}
                    disabled={btnLoading}
                  >
                    {btnLoading ? "Shortlisting" : "Shortlist this tender"}
                  </Button>
                )}
              </Box>
            </Box>
          )
        )}
      </Box>
      <Box className="dashboard-container">
        <Box
          sx={{
            display: "flex",
            gap: 1,
            pt: 2,
            borderBottom: "1px solid #dedede",
          }}
        >
          <Button
            className={`dashboard-btns ${
              status === "SHORTLISTED" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setStatus("SHORTLISTED");
              setIsLoading(true);
              localStorage.setItem("activeTab", "SHORTLISTED");
            }}
          >
            Shortlisted <ItemCount count={shortlistCount} />
          </Button>
          <Button
            className={`dashboard-btns ${
              status === "PREBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setIsLoading(true);
              setStatus("PREBIDDING");
              localStorage.setItem("activeTab", "PREBIDDING");
            }}
          >
            Prebidding <ItemCount count={preCount} />
          </Button>
          <Button
            className={`dashboard-btns ${
              status === "INBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setIsLoading(true);
              setStatus("INBIDDING");
              localStorage.setItem("activeTab", "INBIDDING");
            }}
          >
            In Bidding <ItemCount count={inCount} />
          </Button>
          <Button
            className={`dashboard-btns ${
              status === "POSTBIDDING" ? "active" : ""
            }`}
            sx={{ fontSize: "10px" }}
            onClick={() => {
              setIsLoading(true);
              setStatus("POSTBIDDING");
              localStorage.setItem("activeTab", "POSTBIDDING");
            }}
          >
            Post Bidding <ItemCount count={postCount} />
          </Button>
        </Box>
        <Tenders
          tenders={tenders}
          isLoading={isLoading}
          activeTab={status}
          getTenders={getTenders}
          totalCount={totalCount}
        />
      </Box>

      <SuccessModal
        open={open}
        handleClose={handleClose}
        msg={"Tender Shortlisted!"}
      />

      <ErrorModal open={openError} handleClose={handleClose} msg={errorMsg} />

      <Modal
        open={openPurchase}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...style, textAlign: "start" }}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            textAlign={"start"}
          >
            Enter Purchase Details
          </Typography>
          <Typography id="modal-modal-description" mb={2}>
            Please enter Purchase details below <br />
            <br />
            Please transfer the Purchase amount of{" "}
            <strong>
              Rs.{searchTender?.purchaseAmount} on the below account
            </strong>
            <br />
            Account Holder Name:{" "}
            <strong>{searchTender?.purchaseAccountName}</strong>
            <br />
            Account Number:{" "}
            <strong>{searchTender?.purchaseAccountNumber}</strong>
            <br />
            Bank Name: <strong>{searchTender?.purchaseBank}</strong>
            <br />
            IFSC Code: <strong>{searchTender?.purchaseIfsc}</strong>
            <br />
            <br />
            Once paid, please enter the details below
          </Typography>
          <label htmlFor="utr">UTR Number</label>
          <input
            type="text"
            name="utr"
            id="utr"
            placeholder="Enter Your UTR Number Here"
            onChange={handleChange}
            className={`${errors.utr && "input-error"}`}
          />
          {errors.utr && <p className="error">{errors.utr}</p>}
          <label htmlFor="document">
            Upload Document
            <div className={`input-file ${errors.document && "input-error"}`}>
              <input
                type="file"
                id="document"
                name="document"
                onChange={handleFileUpload}
              />
              <span
                style={{
                  width: "80%",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {fileNames.document || "No file chosen"}
              </span>
              <AttachFileIcon
                fontSize="small"
                sx={{
                  color: "#555",
                  transform: "rotate(90deg)",
                  "&:hover": { color: "#1A71F6BF" },
                }}
              />
            </div>
          </label>
          {errors.document && <p className="error">{errors.document}</p>}
          {uploading && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
          {purchase && purchase.document && (
            <Button
              sx={{
                margin: "-6% 0 0 0 !important",
                width: "max-content !important",
                fontSize: "12px !important",
                textDecoration: "underline",
                textAlign: "start",
              }}
              onClick={() => viewPDF(purchase.document, storedUser)}
            >
              {fileNames.document}
            </Button>
          )}
          <Box className="btn-container" sx={{ gap: 4, width: "80%" }}>
            <Button
              className="btn-contained"
              onClick={() => setOpenConfirm(true)}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting" : "Submit"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to submit these details?
          </Typography>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={() => setOpenConfirm(false)}
            >
              No
            </Button>
            <Button
              className="btn-contained"
              onClick={handlePurchaseSubmit}
              disabled={btnLoading}
            >
              {btnLoading ? "Submitting..." : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default MyTenders;
